import drRamakantImg from '../assets/Dr. Ramakant Tekke.jpeg';
import drVishakhaImg from '../assets/Dr. Vishakha Tekke.jpeg';

export const doctors = [
  {
    id: "dr-ramakant-tekke",
    name: "Dr. Ramakant Tekke",
    qualification: "Ophthalmology",
    specialization: "Ophthalmologist",
    profile: "A highly experienced ophthalmologist dedicated to providing comprehensive eye care and advanced surgical treatments.",
    image: drRamakantImg
  },
  {
    id: "dr-vishakha-tekke",
    name: "Dr. Vishakha Tekke",
    qualification: "M.S. (Opth) & M.B.B.S., D.O.M.S.",
    specialization: "Ophthalmologist & Eye Surgeon",
    profile: "Specializes in modern vision correction procedures, cataract surgery, and comprehensive patient eye care.",
    image: drVishakhaImg
  }
];
